export default "__VITE_ASSET__Bbnqfa9J__"